document.querySelectorAll('.smooth-scroll').forEach(anchor => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault(); // デフォルトの挙動（ページ遷移）をキャンセル
        const targetId = this.getAttribute("href").replace("#", "");
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            window.scrollTo({
                top: targetElement.getBoundingClientRect().top + window.pageYOffset - 80,
                behavior: "smooth"
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const fadeInSections = document.querySelectorAll('.fade-in-section');

    const appearOnScroll = new IntersectionObserver(function (entries, observer) {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px" // ビューポートの下から100pxの位置でトリガー
    });

    fadeInSections.forEach(section => {
        appearOnScroll.observe(section);
    });
});


document.querySelectorAll('.faq-question').forEach(question => {
    question.addEventListener('click', function () {
        const answer = this.nextElementSibling;
        const iconPlus = this.querySelector('.plus');
        const iconMinus = this.querySelector('.minus');

        answer.classList.toggle('open');
        if (answer.classList.contains('open')) {
            answer.style.maxHeight = answer.scrollHeight + "px";
            iconPlus.style.display = 'none';
            iconMinus.style.display = 'block';
        } else {
            answer.style.maxHeight = "0";
            iconPlus.style.display = 'block';
            iconMinus.style.display = 'none';
        }
    });
});


document.addEventListener('DOMContentLoaded', function () {
    // readmoreの処理
    var targets = document.querySelectorAll('.readmore');
    var mores = document.querySelectorAll('.more');

    targets.forEach(function (target) {
        var readmoreInner = target.querySelector('.readmore_inner');

        // 一時的に非表示要素を表示して高さを取得する
        var originalDisplay = readmoreInner.style.display;
        readmoreInner.style.display = 'block'; // 要素を一時的に表示
        var initialHeight = readmoreInner.scrollHeight; // 要素の完全な高さを取得
        readmoreInner.style.display = originalDisplay; // 元の表示状態に戻す

        var more = target.nextElementSibling;

        console.log('Initial Height:', initialHeight); // デバッグ用ログ

        if (initialHeight > 100) { // 200px以上ならアコーディオン処理を適用
            target.classList.add('hide');

            more.addEventListener('click', function () {
                var readmore = this.previousElementSibling;
                var morespan = this.querySelector('span');

                if (this.classList.contains('close')) {
                    this.classList.remove('close');
                    readmore.style.maxHeight = '200px';
                    readmore.classList.add('hide');
                    readmore.classList.remove('expanded');
                    morespan.textContent = 'もっと見る';
                    console.log('Closed, max height: 200px'); // デバッグ用ログ
                } else {
                    readmore.style.maxHeight = '3000px'; // max-heightを3000pxに指定
                    readmore.classList.remove('hide');
                    readmore.classList.add('expanded');
                    this.classList.add('close');
                    morespan.textContent = '閉じる';
                    console.log('Opened, max height: 3000px'); // デバッグ用ログ
                    setTimeout(() => {
                        this.style.display = 'none';
                        console.log('More button hidden after 100ms'); // デバッグ用ログ
                    }, 10);
                }
            });
        } else {
            var morespan = more.querySelector('span');
            morespan.parentNode.removeChild(morespan);
            console.log('Morespan removed due to insufficient height.'); // デバッグ用ログ
        }
    });
});